import styled from 'styled-components/macro'
import MuiCardContent from '@material-ui/core/CardContent'

const Content = styled(MuiCardContent)`
  position: relative;
  z-index: 1;
`

export default Content
